import styled, { css } from 'styled-components';
import { colors } from '../../../component/colors';
import { pxToRem } from '../../../utils/pxToRem';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
`;
export const Title = styled.h2`
  font-size: ${pxToRem(21)};
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: ${pxToRem(0.15000000596046448)};
  text-align: left;
`;
export const StatusContainer = styled.div<{ status: boolean }>`
  border-radius: 16px;
  min-width: 68px;
  width: fit-content;
  padding: 4px 8px;
  justify-content: center;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(16)};
  ${({ status }) =>
    status
      ? css`
          background: #7ce374;
          color: #22851b;
        `
      : css`
          background: #ff9179;
          color: #ec2b00;
        `}
`;

export const ActionBtn = styled.button`
  padding: 14px 12px;
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(12)};
  border: none;
  color: #253858;
`;
export const AgentContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: ${pxToRem(12)};
  font-weight: 500;
  line-height: ${pxToRem(12)};
  letter-spacing: 0px;
  color: #8993a4;
  text-align: left;
`;
export const AgentName = styled.p`
  color: #091e42;
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(12)};
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 4px;
`;
export const AgentAvatar = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 20px;
  background-color: ${colors.grey};
  object-fit: cover;
  margin-right: 12px;
`;
